import React from "react";
import Hero from '../Components/Hero/Hero'
import Videos from '../Components/Videos/Videos'
import About from "../Components/About/About"
import Category from '../Components/Category/Category'
import Card from '../Components/Card/Card'
import NewArrival from '../Components/Newarrival/Newarrival'
import Featured from '../Components/Featured/Featured'
import Design from '../Components/Design/Design'
import Customer from '../Components/Customer/Customer'
import Variety from '../Components/Variety/Variety'
import BestSeller from '../Components/BestSeller/BestSeller'
import RetroCollection from '../Components/RertoCollection/Retro'

// Each section fetches its own data, so the page renders immediately
// instead of blocking on API calls.
const Shop = () => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <Hero />
      <About />
      <Videos />
      <Category />
      <Card />
      <NewArrival />
      <Design />
      <RetroCollection />
      <Variety />
      <BestSeller />
      <Featured />
      <Customer />
    </div>
  );
};

export default Shop;
